import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getTagsData } from 'models/tagsdata'; // Importing function to get tags data

/**
 * TagsView class extends JetView to create a view for displaying awarded badges.
 */
export default class TagsView extends JetView {
    /**
     * Configures the layout of the TagsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Awarded Badges'), // Header template with localized text
                    type: 'header', // Specifies this row as a header
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart view for displaying data
                    type: 'barH', // Horizontal bar chart type
                    localId: 'chart', // Local identifier for the chart
                    radius: 0, // No rounded corners for bars
                    barWidth: 20, // Width of the bars
                    value: '#number#', // Data field for bar values
                    border: false, // No border around bars
                    padding: {
                        top: 0, // Top padding
                        left: 20, // Left padding
                        bottom: 40, // Bottom padding
                    },
                    xAxis: {
                        start: 0, // Starting point of the x-axis
                        end: 32, // Ending point of the x-axis
                        step: 4, // Step size for x-axis ticks
                        color: '#fff', // Color of x-axis labels
                        lineColor: '#EDEFF0', // Color of x-axis line
                    },
                    yAxis: {
                        template: '', // Template for y-axis labels
                        lines: false, // Disable lines on y-axis
                        color: '#EDEFF0', // Color of y-axis labels
                    },
                    color: '#color#', // Data field for bar colors
                    legend: {
                        template: (obj) => _(obj.tag), // Template for legend items with localization
                        valign: 'middle', // Vertical alignment of legend
                        align: 'right', // Horizontal alignment of legend
                        width: 130, // Width of the legend
                        marker: {
                            type: 'round', // Shape of legend markers
                            width: 7, // Width of legend markers
                            height: 8, // Height of legend markers
                        },
                    },
                    tooltip: {
                        template: '#number# clients', // Tooltip template for displaying data
                    },
                },
            ],
        };
    }

    /**
     * Initializes the TagsView.
     */
    init() {}
}

// FILE DOCUMENTED
